import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Icon } from '@/components/ui/Icon'
import { CHANGELOG } from '@/data/changelog'

interface ChangelogModalProps {
  onClose: () => void
  unreadCount: number
}

export function ChangelogModal({ onClose, unreadCount }: ChangelogModalProps) {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [onClose])

  return createPortal(
    <div className="cg-modal-backdrop" onClick={onClose}>
      <div className="cg-modal large" onClick={(e) => e.stopPropagation()}>
        <div className="cg-modal-header">
          <h2>What's New</h2>
          <button className="cg-icon-btn cg-modal-close-x" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div style={{ padding: '4px 0 8px', overflowY: 'auto', flex: 1, minHeight: 0 }}>
          {CHANGELOG.map((entry, i) => (
            <div key={entry.version} style={{ padding: '12px 16px', borderBottom: i < CHANGELOG.length - 1 ? '1px solid var(--line-soft)' : undefined }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 4 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--accent)', fontFamily: 'monospace' }}>
                  {entry.version}
                </span>
                <span style={{ fontSize: 12, color: 'var(--fg-3)' }}>
                  {new Date(entry.date + 'T00:00:00').toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                </span>
                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg-1)' }}>
                  {entry.title}
                </span>
                {i < unreadCount && <span className="cg-changelog-badge">New</span>}
              </div>
              <ul style={{ margin: 0, paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 2 }}>
                {entry.changes.map((change) => (
                  <li key={change} style={{ fontSize: 13, color: 'var(--fg-2)', lineHeight: 1.5 }}>
                    {change}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  )
}
